import React from 'react';
//import logo from './logo.svg';
import './App.scss';
import FrontPage from './containers/FrontPage/FrontPage';
import {BrowserRouter as Router, Route} from "react-router-dom";
import KidBoard from "./containers/KidBoard/KidBoard";
import AdultBoard from "./containers/AdultBoard/AdultBoard";
import AdminBoard from "./containers/AdminBoard/AdminBoard";

function App() {
    return (
        <Router>
            <div className="App">
                <Route path='/kid' component={KidBoard}/>
                <Route path='/parent' component={AdultBoard}/>
                <Route path='/admin' component={AdminBoard}/>
                <Route exact path='/' component={FrontPage}/>
            </div>
        </Router>
    );
}

export default App;
